import { gql } from 'apollo-angular';

export const createUserQuery = gql`
  mutation Create_user($user: UserInput!) {
    create_user(row: $user) {
      id
    }
  }
`;

export const updateUserQuery = gql`
  mutation Update_user($id: UUID!, $change: UserInput!) {
    update_user(id: $id, change: $change) {
      id
    }
  }
`;

export const deleteUserQuery = `
  mutation Delete_user($id: UUID!) {
    delete_user(id: $id) {
      id
    }
  }
`;

export const DELETE_USER_BRANCH = gql`
  mutation Delete_user_branch($id: UUID!) {
    delete_user_branch(id: $id) {
      id
    }
  }`;

export const CREATE_USER_BRANCH = gql`
  mutation Create_user_branch($userBranch: UserBranchInput!) {
    create_user_branch(row: $userBranch) {
      id
      user_id
      branch {
        id
        name
        code
        location
      }
      branch_id
    }
  }`;
